/**
 * 商道分支 (💰 经济科技) - 共18项
 * 严格按照 docs/TECH_TREE_DESIGN.md 设计
 */

import type { Tech } from '../TechTypes';

export const SHANGDAO_TECHS: Tech[] = [
  // 第一层：基础商业 (3项)
  {
    id: 'S001',
    name: '以物易物',
    description: '商业起源',
    branch: 'shangdao',
    tier: 1,
    cost: 100,
    researchTime: 1,
    prerequisites: [],
    effects: {
      bonuses: { tradingBonus: 1.1 },
      special: { tradeRoutes: true },
    },
    position: { x: 20, y: 10 },
    icon: '🔄',
  },
  {
    id: 'S002',
    name: '刀币流通',
    description: '货币之始',
    branch: 'shangdao',
    tier: 1,
    cost: 100,
    researchTime: 1,
    prerequisites: [],
    effects: {
      bonuses: { incomeBonus: 1.1 },
    },
    position: { x: 50, y: 10 },
    icon: '🪙',
  },
  {
    id: 'S003',
    name: '集市开设',
    description: '基础商贸',
    branch: 'shangdao',
    tier: 1,
    cost: 100,
    researchTime: 1,
    prerequisites: [],
    effects: {
      bonuses: { marketBonus: 1.15 },
    },
    position: { x: 80, y: 10 },
    icon: '🏪',
  },

  // 第二层：进阶商业 (5项)
  {
    id: 'S011',
    name: '盐铁专营',
    description: '国家专卖',
    branch: 'shangdao',
    tier: 2,
    cost: 200,
    researchTime: 2,
    prerequisites: ['S001', 'S002'],
    effects: {
      bonuses: { mineIncome: 25, incomeBonus: 1.1 },
    },
    position: { x: 10, y: 25 },
    icon: '🧂',
  },
  {
    id: 'S012',
    name: '铜钱统一',
    description: '货币统一',
    branch: 'shangdao',
    tier: 2,
    cost: 200,
    researchTime: 2,
    prerequisites: ['S002'],
    effects: {
      bonuses: { incomeBonus: 1.15, tradingBonus: 1.1 },
    },
    position: { x: 30, y: 25 },
    icon: '💲',
  },
  {
    id: 'S013',
    name: '坊市分离',
    description: '城市规划',
    branch: 'shangdao',
    tier: 2,
    cost: 200,
    researchTime: 2,
    prerequisites: ['S003'],
    effects: {
      bonuses: { marketBonus: 1.25, taxBonus: 1.2 },
    },
    position: { x: 50, y: 25 },
    icon: '🏬',
  },
  {
    id: 'S014',
    name: '商队远行',
    description: '丝路贸易',
    branch: 'shangdao',
    tier: 2,
    cost: 200,
    researchTime: 2,
    prerequisites: ['S001'],
    effects: {
      bonuses: { tradingBonus: 1.2 },
    },
    position: { x: 70, y: 25 },
    icon: '🐪',
  },
  {
    id: 'S015',
    name: '票号钱庄',
    description: '金融起步',
    branch: 'shangdao',
    tier: 2,
    cost: 200,
    researchTime: 2,
    prerequisites: ['S002', 'S003'],
    effects: {
      bonuses: { goldCapacity: 1.5, incomeBonus: 1.1 },
    },
    position: { x: 90, y: 25 },
    icon: '🏦',
  },

  // 第三层：高级商业 (5项)
  {
    id: 'S021',
    name: '丝绸之路',
    description: '国际贸易',
    branch: 'shangdao',
    tier: 3,
    cost: 350,
    researchTime: 3,
    prerequisites: ['S011', 'S014'],
    effects: {
      bonuses: { tradingBonus: 1.4, morale: 1.2 },
    },
    position: { x: 10, y: 45 },
    icon: '🛤️',
  },
  {
    id: 'S022',
    name: '均输平准',
    description: '经济调控',
    branch: 'shangdao',
    tier: 3,
    cost: 350,
    researchTime: 3,
    prerequisites: ['S012', 'S013'],
    effects: {
      bonuses: { marketBonus: 1.3, incomeBonus: 1.1 },
    },
    position: { x: 30, y: 45 },
    icon: '⚖️',
  },
  {
    id: 'S023',
    name: '海上丝路',
    description: '海洋贸易',
    branch: 'shangdao',
    tier: 3,
    cost: 350,
    researchTime: 3,
    prerequisites: ['S014'],
    effects: {
      bonuses: { tradingBonus: 1.5 },
    },
    position: { x: 50, y: 45 },
    icon: '⛵',
  },
  {
    id: 'S024',
    name: '晋商票号',
    description: '金融网络',
    branch: 'shangdao',
    tier: 3,
    cost: 350,
    researchTime: 3,
    prerequisites: ['S015'],
    effects: {
      bonuses: { goldCapacity: 1.5, incomeBonus: 1.2 },
    },
    position: { x: 70, y: 45 },
    icon: '📜',
  },
  {
    id: 'S025',
    name: '官商合作',
    description: '军商结合',
    branch: 'shangdao',
    tier: 3,
    cost: 350,
    researchTime: 3,
    prerequisites: ['S013', 'S015'],
    effects: {
      bonuses: { upkeepReduction: 1.15, incomeBonus: 1.3 },
    },
    position: { x: 90, y: 45 },
    icon: '🤝',
  },

  // 第四层：大师商业 (3项)
  {
    id: 'S031',
    name: '富可敌国',
    description: '财富帝国：可用金币买通敌军',
    branch: 'shangdao',
    tier: 4,
    cost: 500,
    researchTime: 4,
    prerequisites: ['S021', 'S024'],
    effects: {
      bonuses: { incomeBonus: 1.5 },
    },
    position: { x: 20, y: 65 },
    icon: '👑',
  },
  {
    id: 'S032',
    name: '万国来朝',
    description: '贸易霸权',
    branch: 'shangdao',
    tier: 4,
    cost: 500,
    researchTime: 4,
    prerequisites: ['S021', 'S023'],
    effects: {
      bonuses: { tradingBonus: 1.5, morale: 1.3 },
    },
    position: { x: 50, y: 65 },
    icon: '🌍',
  },
  {
    id: 'S033',
    name: '垄断经营',
    description: '经济战争：敌方贸易收入-25%',
    branch: 'shangdao',
    tier: 4,
    cost: 500,
    researchTime: 4,
    prerequisites: ['S022', 'S025'],
    effects: {
      bonuses: { marketBonus: 1.5 },
      special: { marketMonopoly: true },
    },
    position: { x: 80, y: 65 },
    icon: '🏢',
  },

  // 第五层：终极商业 (2项) [互斥]
  {
    id: 'S041',
    name: '点石成金',
    description: '财富终极：金币收入+80%，科技花费-25%',
    branch: 'shangdao',
    tier: 5,
    cost: 800,
    researchTime: 5,
    prerequisites: ['S031'],
    mutuallyExclusive: ['S042'],
    effects: {
      bonuses: { incomeBonus: 1.8, researchSpeedBonus: 1.25 },
    },
    position: { x: 35, y: 85 },
    nodeShape: 'hexagon',
    icon: '💎',
    quote: '天下熙熙，皆为利来',
  },
  {
    id: 'S042',
    name: '天下通商',
    description: '贸易终极：贸易胜利条件达成，经济制裁能力',
    branch: 'shangdao',
    tier: 5,
    cost: 800,
    researchTime: 5,
    prerequisites: ['S032', 'S033'],
    mutuallyExclusive: ['S041'],
    effects: {
      bonuses: { tradingBonus: 2.0, marketBonus: 1.5 },
      special: { sabotage: true },
    },
    position: { x: 65, y: 85 },
    nodeShape: 'hexagon',
    icon: '🌐',
    quote: '货通天下，利济苍生',
  },
];
